var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useGetModuleRecordQuery } from "@/store/api";
import { Link } from "react-router-dom";
/** <b>Composant en mode consultation/detail d'un champ de type parent</b>*/
export default function ParentFieldDetail(_a) {
    var fieldName = _a.fieldName, record = _a.record, fieldMetadata = _a.fieldMetadata;
    var parent_type = fieldMetadata.type_name;
    var idFieldName = fieldMetadata.id_name;
    var moduleName = record[parent_type];
    var recordId = record[idFieldName];
    var response = useGetModuleRecordQuery({
        moduleName: moduleName,
        recordId: recordId,
    }).data;
    var parentRecord = (response === null || response === void 0 ? void 0 : response.data.record) || {};
    var relateId = (parentRecord && (parentRecord === null || parentRecord === void 0 ? void 0 : parentRecord.id)) || "";
    var link = "".concat(process.env.PUBLIC_URL, "/modules/").concat(record[parent_type], "/DetailView/").concat(relateId);
    return (_jsx("span", __assign({ className: "flex items-center text-blue-700 hover:text-blue-400" }, { children: _jsx(Link, __assign({ to: link }, { children: parentRecord && (parentRecord === null || parentRecord === void 0 ? void 0 : parentRecord.name) })) })));
}
